export default "__VITE_ASSET__c4355d68__"